<xemex-dialog-shell [title]="'locations.coordinates.title' | translate">
  <div class="coordinate-dialog">
    @if (isLoading()) {
      <xemex-spinner />
    } @else if (loadFailed()) {
      <div class="flex items-center justify-between gap-4">
        <span>{{ 'locations.coordinates.loadFailed' | translate }}</span>
        <xemex-text-button icon="refresh" (click)="load()">
          {{ 'installations.insights.retry' | translate }}
        </xemex-text-button>
      </div>
    } @else if (pin(); as current) {
      <p class="coordinate-dialog__lead">{{ 'locations.coordinates.lead' | translate }}</p>

      <google-map
        class="coordinate-dialog__map"
        height="320px"
        width="100%"
        [options]="options()"
        [center]="center()"
      >
        <map-marker
          [position]="current"
          [options]="markerOptions"
          (mapDragend)="onDragEnd($event)"
        />
      </google-map>

      @if (messageKey(); as key) {
        <p class="text-text-error" role="alert">{{ key | translate }}</p>
      }

      <div class="coordinate-dialog__facts">
        <xemex-detail-field [label]="'locations.coordinates.pin' | translate">
          {{ current.lat.toFixed(6) }}, {{ current.lng.toFixed(6) }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'locations.coordinates.timezone' | translate">
          {{ result()?.timezone ?? '–' }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'locations.coordinates.source.label' | translate">
          {{
            'locations.coordinates.source.' + (location()?.coordinateSource ?? 'unknown')
              | translate
          }}
        </xemex-detail-field>
        @if (location()?.coordinateSetAt) {
          <xemex-detail-field [label]="'locations.coordinates.setAt' | translate">
            {{ location()?.coordinateSetAt | date: 'medium' }}
          </xemex-detail-field>
        }
        @if (offsetMetres() !== null) {
          <xemex-detail-field [label]="'locations.coordinates.offset' | translate">
            {{ 'locations.coordinates.offsetValue' | translate: { metres: offsetMetres() } }}
          </xemex-detail-field>
        }
      </div>

      <section class="coordinate-dialog__installations" aria-live="polite">
        <h3 class="coordinate-dialog__heading">
          {{ 'locations.coordinates.installations.title' | translate }}
        </h3>
        @if (isPreviewing()) {
          <xemex-spinner size="sm" />
        } @else if (previewFailed()) {
          <p class="text-text-error" role="alert">
            {{ 'locations.coordinates.errors.previewFailed' | translate }}
          </p>
        } @else if (hostsNoInstallation()) {
          <p class="coordinate-dialog__note">
            {{ 'locations.coordinates.installations.none' | translate }}
          </p>
        } @else if (result()) {
          <xemex-table
            [data]="installationRows()"
            [columns]="installationColumns"
            [pageable]="false"
            [compact]="true"
          />
        }
      </section>

      <xemex-text-field
        [label]="'locations.coordinates.reason' | translate"
        [placeholder]="'locations.coordinates.reasonPlaceholder' | translate"
        [invalid]="reasonTooLong()"
        [errorText]="'locations.coordinates.reasonTooLong' | translate: { max: reasonMaxLength }"
        [ngModel]="reason()"
        (ngModelChange)="reason.set($event)"
      />
    } @else if (messageKey(); as key) {
      <p class="text-text-error" role="alert">{{ key | translate }}</p>
    }
  </div>

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    @if (pin()) {
      <xemex-filled-button [disabled]="!canSave()" [loading]="isSaving()" (click)="save()">
        {{ 'locations.coordinates.save' | translate }}
      </xemex-filled-button>
    }
  </div>
</xemex-dialog-shell>
